import { WorkflowItemCode } from '../../app/constants';

export const landingPage = {
  id: '64465471e95e7500114dd936',
  code: WorkflowItemCode.LANDING_PAGE,
  capturesPii: false,
  lastItem: false,
  configuration: {},
  localizedContentMap: [],
  nestedItems: [
    {
      id: '64465471e95e7500114dd930',
      code: WorkflowItemCode.GENCONTENT,
      lastItem: false,
      capturesPii: false,
      configuration: JSON.stringify({
        display: 'gen2c',
        configWidget: 'GeneralContentItemConfigurationWidget',
        code: 'GENCONTENT',
        currentTemplateId: '7946',
        configWidgetJSON: {
          layout: 'LAYOUT_08',
          backgroundImageEnabled: false,
          backgroundColor: '#F4F5F7',
          backgroundImage: null,
          content: 'gen_content_layout_content',
          name: 'gen1c',
          mediaUrl: {
            name: 'Chrysanthemum.jpg',
            path: 'http://via.placeholder.com/760x350',
            uuid: 'c4cf6f1443ed43d5961a64b4342f07e2',
          },
          mediaAlignment: 'RIGHT',
          title: 'gen_content_title',
          titleColor: '#000000',
        },
      }),
      localizedContentMap: [
        {
          key: 'gen_content_title',
          value: 'Problem Statement',
        },
        {
          key: 'gen_content_layout_content',
          value: `<p>Text detection is a fundamental component of OCR applications. One of the typical use cases is to detect multilingual text in a natural environment (where multilingual text can consist of characters, digits and punctuation). However, in real life, the image captured by a user may be blurred, distorted and have poor resolution, which can greatly reduce the accuracy and reliability of OCR text detection. To achieve an ideal result, it will be necessary to utilize advanced machine learning methods in the design of the OCR engine.</p>`,
        },
      ],
    },
    {
      id: '64465471e95e7500114dd932',
      code: WorkflowItemCode.GENCONTENT,
      lastItem: false,
      capturesPii: false,
      configuration: JSON.stringify({
        display: 'gen2c',
        configWidget: 'GeneralContentItemConfigurationWidget',
        code: 'GENCONTENT',
        currentTemplateId: '7946',
        configWidgetJSON: {
          layout: 'LAYOUT_09',
          backgroundImageEnabled: 'true',
          backgroundColor: '',
          backgroundImage: {
            name: 'gh_background_6_690abaccb81144fe9f4f97250d4e4138_cc8d7f802a454e488353643961d31d1a.jpg',
            path: '/resource/3027301/gh_background_6_690abaccb81144fe9f4f97250d4e4138_cc8d7f802a454e488353643961d31d1a_84736bf49b794e82baef094b3af325e6.jpg',
            uuid: 'b9225e0bc483490295b6f44b2ab5e0bf',
          },
          title: 'gen_content_title',
          titleColor: '#000000',
          contentTextColor: '#000000',
          contentContainerBackgroundColor: '#FFFFFF',
          items: [
            {
              title: 'Who is this Hackathon for?',
              description: 'College graduates would be the focus audience for this Hackathon',
              mediaUrl: {
                name: 'Chrysanthemum.jpg',
                path: 'http://via.placeholder.com/200x200',
                uuid: 'c4cf6f1443ed43d5961a64b4342f07e2',
              },
            },
            {
              title: 'Who is this Hackathon for2?',
              description:
                'College graduates would be the focus audience for this Hackathon College graduates would be the focus audience for this Hackathon College graduates would be the focus audience for this Hackathon College graduates would be the focus audience for this Hackathon College graduates would be the focus audience for this Hackathon College graduates would be the focus audience for this Hackathon',
              mediaUrl: {
                name: 'Chrysanthemum.jpg',
                path: 'http://via.placeholder.com/300x300',
                uuid: 'c4cf6f1443ed43d5961a64b4342f07e2',
              },
            },
            {
              title: 'Who is this Hackathon for3?',
              description: 'College graduates would be the focus audience for this Hackathon',
            },
          ],
        },
      }),
      localizedContentMap: [
        { key: 'gen_content_title', value: 'Prizes' },
        // {
        //   key: 'gen_content_layout_content',
        //   value: `<p>Text detection is a fundamental component of OCR applications. One of the typical use cases is to detect multilingual text in a natural environment (where multilingual text can consist of characters, digits and punctuation). However, in real life, the image captured by a user may be blurred, distorted and have poor resolution, which can greatly reduce the accuracy and reliability of OCR text detection. To achieve an ideal result, it will be necessary to utilize advanced machine learning methods in the design of the OCR engine.</p>`,
        // },
      ],
    },
    {
      id: '64465471e95e7500114dd931',
      code: WorkflowItemCode.GENCONTENT,
      lastItem: false,
      capturesPii: false,
      configuration: JSON.stringify({
        display: 'gen2c',
        configWidget: 'GeneralContentItemConfigurationWidget',
        code: 'GENCONTENT',
        currentTemplateId: '7946',
        configWidgetJSON: {
          layout: 'LAYOUT_10',
          backgroundColor: '#27263A',
          title: 'gen_content_title',
          titleColor: '#FFFFFF',
          contentTextColor: '#000000',
          contentContainerBackgroundColor: '#FFFFFF',
          stripColor: '#FFCC00',
          items: [
            {
              title: 'Who is this Hackathon for?',
              description: 'College graduates would be the focus audience for this Hackathon',
            },
            {
              title: 'Who is this Hackathon for2?',
              description:
                'College graduates would be the focus audience for this Hackathon College graduates would be the focus audience for this Hackathon College graduates would be the focus audience for this Hackathon College graduates would be the focus audience for this Hackathon College graduates would be the focus audience for this Hackathon College graduates would be the focus audience for this Hackathon',
            },
            {
              title: 'Who is this Hackathon for3?',
              description: 'College graduates would be the focus audience for this Hackathon',
            },
          ],
        },
      }),
      localizedContentMap: [{ key: 'gen_content_title', value: 'FAQs' }],
    },
  ],
};
